<template>
  <div class="down-left" v-cdrag v-show="show">
    <base-button @click="$store.state.WaitTasks.show = true">{{
      $t("general.ImportantMsg")
    }}</base-button>
  </div>
</template>

<script>
import BaseButton from "../BaseComponents/BaseButton.vue";

export default {
  components: { BaseButton },
  computed: {
    show() {
      return this.$store.state.WaitTasks.tasks.filter((a) => a.status != "done")
        .length;
    },
  },
};
</script>

<style scoped>
.down-left {
  position: fixed;
  z-index: 9;
  bottom: 80px;
  left: 40px;
}
</style>
